module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms2.9cc34c8b845407879e2941b1df203fd7.png";